var viewer_rtlignore_default = {
  "gallery_container": "Cr0YY",
  "imageTitleContainer": "bs-vB",
  "clickableItem": "uwDDH",
  "prerender": "_0Bn9g",
  "expandContainer": "nF9qJ",
  "expandIcon": "ycOOE",
  "itemOverlay": "_9a-gg",
  "imageTitle": "_7lMVm",
  "pointer": "r1u0N",
  "fadeIn": "Jdheb",
  "changing_background": "rkO58"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
